<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Cost Center"
      text="Create Cost Center"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="costCenterName"
                    v-validate="'required'"
                    label="Cost Center Name"
                    :error-messages="errors.collect('costCenterName')"
                    data-vv-name="costCenterName"
                    data-vv-as="cost center name"
                    outlined
                  />
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12">
                  <div>Is belongs to <span class="font-weight-bold primary--text">{{ selectedCompanyName }}</span> ?</div>

                  <v-radio-group
                    v-model="isActualCompany"
                    v-validate="'required'"
                    :error-messages="errors.collect('isActualCompany')"
                    data-vv-name="isActualCompany"        
                    data-vv-as="is actual company"        
                    row
                  >
                    <v-radio
                      label="Yes"
                      :value="1"
                    /> 
                    <v-radio
                      label="No"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row 
                v-if="!isActualCompany" 
                no-gutters
              >
                <v-col cols="12">
                  <v-autocomplete
                    v-model="actualCompany"
                    v-validate="'required'"
                    :items="companies"
                    item-text="name"
                    item-value="id"
                    value="id"
                    :error-messages="errors.collect('actualCompany')"
                    data-vv-name="actualCompany"
                    data-vv-as="actual company"
                    label="Actual Company"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="addressLine1"
                    v-validate="costCenterName?'required':''"
                    :error-messages="errors.collect('addressLine1')"
                    data-vv-name="addressLine1"
                    data-vv-as="address"
                    :disabled="!costCenterName"
                    :filled="!costCenterName"
                    label="Address Line 1"
                    outlined
                  />
                </v-col>
                
                <v-col cols="12">
                  <v-text-field
                    v-model="addressLine2"
                    :disabled="!addressLine1"
                    :filled="!addressLine1"
                    label="Address Line 2"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="addressLine3"
                    :disabled="!addressLine1"
                    :filled="!addressLine1"
                    label="Address Line 3"
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="postcode"
                    v-validate="'required'"
                    :items="postcodes"
                    item-text="postcode"
                    item-value="postcode"
                    value="postcode"
                    :error-messages="errors.collect('postcode')"
                    data-vv-name="postcode"
                    data-vv-as="postcode"
                    label="Postcode"
                    outlined
                    @input="postCodeOnChanged(postcode)"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="city"
                    v-validate="costCenterName?'required':''"
                    :disabled="dropdownDisabled"
                    :filled="!postcode"
                    :items="filteredCities"
                    :error-messages="errors.collect('city')"
                    data-vv-name="city"
                    data-vv-as="city"
                    item-text="name"
                    item-value="id"
                    value="id"
                    label="City"
                    hide-selected
                    outlined
                    @input="cityOnChanged(city)"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="state"
                    v-validate="costCenterName?'required':''"
                    :error-messages="errors.collect('state')"
                    data-vv-name="state"
                    data-vv-as="state"
                    disabled
                    :filled="!city"
                    :items="states"
                    item-text="name"
                    item-value="id"
                    value="id"
                    label="State"
                    hide-selected
                    outlined
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="country"
                    v-validate="costCenterName?'required':''"
                    :error-messages="errors.collect('country')"
                    data-vv-name="country"
                    data-vv-as="country"
                    :items="countries"
                    disabled
                    :filled="!state"
                    item-text="name"
                    item-value="id"
                    value="id"
                    label="Country"
                    hide-selected
                    outlined
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyId: {
        type: String,
        required: true,
      },
      selectedCompanyName: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        loading: false,
        progressing: false,
        postcodes: [],
        cities: [],
        states: [],
        countries: [],
        companies: [],
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        postcode: null,
        city: null,
        state: null,
        country: null,
        costCenterName: null,
        actualCompany: null,
        isActualCompany: 1,
        dropdownDisabled: null,
        cityIds: [],
      }
    },
    computed: {
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        Promise.all([
          this.$api.countries().list(),
          this.$api.states().list(),
          this.$api.cities().list(),
          this.$api.postcodes().list(),
          this.$api.hrisCompanies().list(),
        ])
          .then(([countries, states, cities, postcodes, companies]) => {
            this.countries = countries.data
            this.states = states.data
            this.cities = cities.data
            this.postcodes = _.orderBy(postcodes.data, ['postcode'], ['asc'])
            this.companies = companies.data.filter(company => {
              return company.id !== this.companyId
            })

            this.loading = false
          })
      },
    },
    methods: { 
      prepareFormData () {
        return {
          selected_company_uid: this.companyId,
          actual_company_uid: this.isActualCompany ? this.companyId : this.actualCompany,
          name: this.costCenterName,
          address_line_one: this.addressLine1,
          address_line_two: this.addressLine2,
          address_line_three: this.addressLine3,
          postcode: this.postcode,
          city_id: this.city,
          state_id: this.state,
          country_id: this.country,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
            
            this.$api.costCenters().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new cost center' })

                  this.dialog = false               
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      postCodeOnChanged (postcodeValue) {
        this.city = null
        this.state = null
        this.country = null
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true
          
          let cityId = (this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }) || {}).city_id

          if (cityId) {
            var cityObject = this.getCity(cityId)
            if (cityObject) {
              this.city = cityObject.id
              var stateObject = this.getState(cityObject.state_id)
              
              if (stateObject) {
                this.state = stateObject.id
                var countryObject = this.getCountry(stateObject.country_id)
                this.country = countryObject.id
              }
            }
          }
        }
      },
      cityOnChanged (cityId) {
        var cityObject = this.getCity(cityId)
        if (cityObject) {
          var stateObject = this.getState(cityObject.state_id)
          
          if (stateObject) {
            this.state = stateObject.id
            var countryObject = this.getCountry(stateObject.country_id)
            this.country = countryObject.id
          }
        }
      },      
      getCity (cityId) {
        if (isNaN(parseInt(cityId))) return null
        return this.cities.find(city => {
          return city.id === parseInt(cityId)
        })
      },
      getState (stateId) {
        if (isNaN(parseInt(stateId))) return null
        return this.states.find(state => {
          return state.id === parseInt(stateId)
        })
      },
      getCountry (countryId) {
        if (isNaN(parseInt(countryId))) return null
        return this.countries.find(country => {
          return country.id === parseInt(countryId)
        })
      },
  
    },
  }
</script>
